<template>
  <div class="index" ref="schema" v-if="isUser && draw" :style="{paddingTop: deviceType === 'weixin' ? '0px' : '48px'}">
    <van-nav-bar class="head bg-color-theme" fixed ref="head" v-if="deviceType !== 'weixin'">
      <template #title>
        <div style="color: #FFFFFF;font-size: 14px;">健康问卷调查{{deviceType}}</div>
      </template>
      <template #left>
        <van-icon name="arrow-left" @click="$router.go(-1)"/>
      </template>
    </van-nav-bar>
    <div class="body" ref="body">
      <div class="question-main">
        <div class="area-content">
          <div>
            区域：{{area}}
          </div>
          <div>
            地点：{{address}}
          </div>
        </div>
        <van-form @submit="onSubmit">
          <div class="title">一、基本信息</div>
          <van-cell-group inset :border="false">
            <van-field
                v-model="question.name"
                name="姓名"
                label="姓名："
                placeholder="请输入姓名"
                :border="false"
                :rules="[{ required: true, message: '请输入姓名' }]"
            />
            <van-field
                name="radio"
                label="性别："
                :border="false"
                :rules="[{ required: true, message: '请选择性别' }]"
            >
              <template #input>
                <van-radio-group v-model="question.sex" direction="horizontal">
                  <van-radio checked-color="#fe8302" name="male">男</van-radio>
                  <van-radio checked-color="#fe8302" name="female">女</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
                v-model="question.birthStr"
                is-link
                readonly
                name="calendar"
                label="出生日期："
                :border="false"
                placeholder="点击选择日期"
                @click="showCalendar = true"
            />
<!--            <van-calendar-->
<!--                v-model:show="showCalendar"-->
<!--                :min-date="new Date(1902, 0, 1)"-->
<!--                color="#33c0b2"-->
<!--                @confirm="onConfirm"/>  -->

            <van-popup
                v-model="showCalendar"
                position="bottom"
                :style="{ height: '50%' }">
              <van-datetime-picker
                  v-model="question.birthday"
                  type="date"
                  title="请选择出生日期"
                  :min-date="minDate"
                  :max-date="maxDate"
                  @confirm="showCalendar = false;onConfirm();"
                  @cancel="showCalendar = false"
              />
            </van-popup>
            <van-field
                v-model="question.age"
                name="年龄"
                label="年龄："
                type="digit"
                :border="false"
                placeholder="请输入年龄"
                :rules="[{ required: true, message: '请输入年龄' }]"
            />
            <van-field
                v-model="question.height"
                name="身高"
                label="身高(cm)："
                type="digit"
                :border="false"
                placeholder="请输入身高"
                :rules="[{ required: true, message: '请输入身高' }]"
            >
<!--              <template #button>-->
<!--                <van-button size="small">cm</van-button>-->
<!--              </template>-->
            </van-field>
            <van-field
                v-model="question.weight"
                name="体重"
                type="digit"
                label="体重(kg)："
                :border="false"
                placeholder="请输入体重"
                :rules="[{ required: true, message: '请输入体重' }]"
            >
            </van-field>
            <van-field
                v-model="question.phone"
                name="联系电话"
                label="联系电话："
                type="tel"
                :border="false"
                placeholder="请输入联系电话"
                :rules="[{ required: true, message: '请输入联系电话' },
                         {pattern: /^1[3456789]\d{9}$|^0\d{2,3}-?\d{7,8}$/, message: '请输入正确的联系方式', trigger: 'onBlur'}]"
            />
          </van-cell-group>
          <div v-for="(item ,index) in questionArr" :key='index' class="no-form-label">
            <div class="title">{{ item.oneTitle }}</div>
            <van-cell-group inset :border="false">
              <div v-for="(opItem,opIndex) in item.questionSon" :key='opIndex' v-if="showSecondQue(opItem)" :id="opItem.sonKey">
                <div class="question">{{ opItem.title }}</div>
                <van-field
                    :border="false"
                    name="radio"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                  <template #label>
                    <div></div>
                  </template>
                  <template #input>
                    <van-radio-group
                        direction="horizontal"
                        v-model="question[opItem.key]"
                        v-if="item.questionSon && !opItem.multiple"
                        @change="changeSelect($event,opItem)">
                      <van-radio
                          :name="n.val+''"
                          v-for="(n,j) in opItem.options"
                          :key='j'
                          checked-color="#fe8302">
                        {{ n.title }}
                      </van-radio>
                    </van-radio-group>
                    <van-checkbox-group
                        v-model="question[opItem.key]"
                        v-if="opItem.multiple"
                        direction="horizontal">
                      <van-checkbox
                          shape="square"
                          :name="n.val+''"
                          v-for="(n,j) in opItem.options"
                          :key='j'
                          checked-color="#fe8302">
                        {{ n.title }}
                      </van-checkbox>


                     <van-field
                        v-if="opItem.key === 'relativesDisease'"
                        v-model="question.otherDisease"
                        placeholder="请输入其他疾病"
                        :border="true"
                    />


                    </van-checkbox-group>
                  </template>
                </van-field>
              </div>
            </van-cell-group>
          </div>
          <div class="submit-fix">
<!--            style="position: absolute;margin: 16px;bottom: 12px;right: 12px;left: 12px;"-->
            <van-button color="#33bdae" round block type="primary" native-type="submit">
              提交健康问卷
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
const handler = function (e) {
  e.preventDefault();
};
export default {
  name: 'Index',
  data() {
    return {
      minDate: new Date(1902, 0, 1),
      maxDate: new Date(2025, 10, 1),
      deviceType: sessionStorage.getItem('deviceType'),
      area: '',
      address: '',
      origin: this.$route.query.origin,
      draw: false,
      showCalendar: false,
      question: {
        age: '',
        name: '',
        sex: '',
        birthStr: '',
        birthday: new Date(),
        height: '',
        tel: '',
        weight: '',
        isReDisease: '',
        relativesDisease: [],
        isNowDisease: '',
        nowDisease: [],
        isMedicine: [],
        medicine: [],
        sportType: [],
      },
      //question:
      //{"age":"33","name":"测试A2","sex":"male","birthStr":"2022年09月17日","birthday":"[native Date Sat Sep 17 2022 20:12:45 GMT+0800 (中国标准时间)]","height":"11","tel":"","weight":"222","isReDisease":"1","relativesDisease":["hypertension"],"isNowDisease":"1","nowDisease":["hypertension"],"isMedicine":"1","medicine":[],"sportType":[],"phone":"17863927100","isDoHeart":"1","fourSeven":"1","fourNine":"2","fourEight":"occas","fourTen":"occas","fourEleven":"occas","fourTwelve":"occas","dizzy":"occas","isInsomnia":"occas","isSmoking":"2","isDrinking":"2","isLate":"2","isSleep":"2","sport":"1","areaName":"青岛1","channelName":"医院1"},
      questionArr: [
        {
          oneTitle: "二、健康史 - 家族史",
          questionSon: [
            {
              title: '1.您的父母或兄弟姐妹是否患有明确诊断的心脑血管疾病?',
              key: 'isReDisease',
              options: [{title: 'A.是', val: 1}, {title: 'B.否', val: 2}]
            },
            {
              title: '2.请选择疾病的名称：(可多选)',
              key: 'relativesDisease',
              multiple: true,
              options: [
                {title: 'A.高血压病 ', val: 'hypertension'}, {title: 'B.高血糖', val: 'hyperglycemia'},
                {title: 'C.高血脂', val: 'hyperlipidemia'}, {title: 'D.冠心病', val: 'coronary'},
                {title: 'E.心力衰竭', val: 'heartFailure'}, {title: ' F.糖尿病', val: 6},
                {title: 'G.肥胖症', val: 'obesity'}, {title: 'H.其他', val: 'other'},
              ]
            },
          ]
        },
        {
          oneTitle: "三、健康史 - 现病史 ",
          questionSon: [
            {
              title: '3.您是否患有明确诊断的心血管疾病或异常?',
              key: 'isNowDisease',
              options: [{title: 'A.是', val: 1}, {title: 'B.否', val: 2}]
            },
            {
              title: '4.请您确认具体疾病或异常的名称：(可多选) ',
              key: 'nowDisease',
              multiple: true,
              options: [
                {title: 'A.高血压病 ', val: 'hypertension'}, {title: 'B.高血糖', val: 'hyperglycemia'},
                {title: 'C.高血脂 ', val: 'hyperlipidemia'}, {title: 'D.心律失常', val: 'arrhythmia'},
                {title: 'E.无', val: 'none'},
              ]
            },
            {
              title: '5.您是否长期服用药物?(连续服用6个月以上，平均每日服用一次以上)',
              key: 'isMedicine',
              sonShow: true,
              sonKey: 'medicine',
              options: [{title: 'A.是', val: 1}, {title: 'B.否', val: 2}]
            },
            {
              title: '5-1.您长期服用哪些药物?(可多选)',
              key: 'medicine',
              show: false,
              multiple: true,
              secondLevel: true,
              parentKey: 'isMedicine',
              options: [
                {title: 'A.降压药', val: 'hypotensor'}, {title: 'B.降糖药', val: 'diabetes'},
                {title: 'C.调脂药(降脂药)', val: 'lipidLower'}, {title: 'D.抗心律失常药', val: 'antiarrhythmic'},
                {title: 'E.中草药', val: 'medicineZH'}, {title: 'F.其他', val: 'other'},
              ]
            },
            {
              title: '6.您是否因心脏病进行过微创手术治疗?',
              key: 'isDoHeart',
              options: [{title: 'A.是', val: 1}, {title: 'B.否', val: 2}]
            },
          ]
        },
        {
          oneTitle: "四、躯体症状(最近3个月) ",
          questionSon: [
            {
              title: '7.您感觉身体总体健康状况如何?',
              key: 'fourSeven',
              options: [
                {title: 'A.好', val: 1}, {title: 'B.一般', val: 2},
                {title: 'C.差', val: 3}
              ]
            },
            {
              title: '8.您感到疲劳乏力或周身明显不适吗?',
              key: 'fourEight',
              options: [
                {title: 'A.没有', val: 'non'}, {title: 'B.偶尔', val: 'occas'},
                {title: 'C.经常', val: 'often'}
              ]
            },
            {
              title: '9.您有心慌心悸（心跳过快）的感觉吗?',
              key: 'fourNine',
              options: [
                {title: 'A.没有', val: 1}, {title: 'B.轻微', val: 2},
                {title: 'C.明显', val: 3}
              ]
            },
            {
              title: '10.您感到有胸闷气喘或呼吸困难吗?',
              key: 'fourTen',
              options: [
                {title: 'A.没有', val: 'non'}, {title: 'B.偶尔', val: 'occas'},
                {title: 'C.经常', val: 'often'}
              ]
            },
            {
              title: '11.您感到心跳无力吗?',
              key: 'fourEleven',
              options: [
                {title: 'A.没有', val: 'non'}, {title: 'B.偶尔', val: 'occas'},
                {title: 'C.经常', val: 'often'}
              ]
            },
            {
              title: '12.您出现心脏偷停吗?',
              key: 'fourTwelve',
              options: [
                {title: 'A.没有', val: 'non'}, {title: 'B.偶尔', val: 'occas'},
                {title: 'C.经常', val: 'often'}
              ]
            },
            {
              title: '13.您感到头晕或头昏吗?',
              key: 'dizzy',
              options: [
                {title: 'A.没有', val: 'non'}, {title: 'B.偶尔', val: 'occas'},
                {title: 'C.经常', val: 'often'}
              ]
            },
            {
              title: '14.您是否经常失眠？',
              key: 'isInsomnia',
              options: [
                {title: 'A.没有', val: 'non'}, {title: 'B.偶尔', val: 'occas'},
                {title: 'C.经常', val: 'often'}
              ]
            },
          ]
        },
        {
          oneTitle: "五、生活习惯",
          questionSon: [
            {
              title: '15.您吸烟吗?(持续吸烟1年以上)',
              key: 'isSmoking',
              options: [{title: '不吸', val: 1}, {title: '吸烟', val: 2}]
            },
            {
              title: '16.您喝洒吗?(平均每周饮酒2次以上)',
              key: 'isDrinking',
              options: [{title: 'A.不喝', val: 1}, {title: 'B.喝', val: 2},]
            },
            {
              title: '17.您熬夜吗？(平均每周熬夜2次以上)',
              key: 'isLate',
              options: [{title: 'A.不熬夜', val: 1}, {title: 'B.熬夜', val: 2},]
            },
            {
              title: '18. 您睡眠质量好吗？',
              key: 'isSleep',
              options: [
                {title: 'A.正常', val: 1}, {title: 'B.失眠', val: 2},
                {title: 'C.睡眠中呼吸暂停 ', val: 3}, {title: 'D.鼾声如雷', val: 4},
              ]
            },
            {
              title: '19.您参加运动锻炼吗?',
              key: 'sport',
              sonShow: true,
              sonKey: 'surveyFiveOne',
              options: [
                {title: 'A.不参加', val: 1}, {title: 'B.偶然参加', val: 2},
                {title: 'C.经常参加(平均每周锻炼3次及以上，每次锻炼30分钟)', val: 3},
              ]
            },
            {
              title: '19-1.您常采用的运动锻炼方式：(可多选)',
              key: 'sportType',
              show: false,
              multiple: true,
              secondLevel: true,
              parentKey: 'sport',
              options: [
                {title: 'A.散步', val: 1}, {title: 'B.慢跑', val: 2},
                {title: 'C.游泳', val: 3}, {title: 'D.骑自行车', val: 4},
                {title: 'G.爬楼梯', val: 5}, {title: 'H.球类', val: 6},
                {title: 'I.跳舞', val: 7}, {title: 'J.瑜伽', val: 8},
                {title: 'K.健身操', val: 9}, {title: 'L.力量锻炼', val: 10},
                {title: 'M.登山', val: 11}, {title: 'L.太极拳', val: 12},
                {title: 'L.其他', val: 13},
              ]
            },
            {
              title: '19-2.您每周锻炼几次？',
              key: 'sportNum',
              show: false,
              secondLevel: true,
              parentKey: 'sport',
              options: [
                {title: 'A.1-2次', val: 1}, {title: 'B.3-5次', val: 2},
                {title: 'C.>5次', val: 3},
              ]
            },
            {
              title: '19-3.您每次锻炼多次时间？',
              key: 'sportTime',
              show: false,
              secondLevel: true,
              parentKey: 'sport',
              options: [
                {title: 'A.<30分钟', val: 1}, {title: 'B.30-60分钟', val: 2},
                {title: 'C.>60分钟', val: 3},
              ]
            },
          ]
        },
      ]
    }
  },
  watch: {
    showCalendar: function (val) {
      if (val) {
        document.getElementsByTagName('body')[0].addEventListener('touchmove', this.handler, {passive: false});
      } else {
        document.getElementsByTagName('body')[0].addEventListener('touchmove', this.handler, {passive: false});
      }
    }
  },

  methods: {
    async onSubmit() {
      this.question.areaName = this.area
      this.question.channelName = this.address
      let res = await this.$axios.post(
          '/api/user/insertHealthQue',
          {
            question: this.question,
            adviserPhone: sessionStorage.getItem('adviserPhone')
          }
      );
      await this.$router.push('/end')
    },

    /**
     * 选项改变回调
     */
    changeSelect(val, info) {

    },

    onConfirm(date) {
      console.log("date", date);
      this.showCalendar = false
      //this.question.birthday = date
      this.question.birthStr = this.$util.transformDate(this.question.birthday)
    }
  },
  mounted: function () {
    this.draw = true;
    let {area, address} = this.$route.query
    this.area = area
    this.address = address
    this.question.birthStr = this.$util.transformDate(new Date())
    this.question.birthday = new Date()
  },

  computed: {

    isUser: function () {
      return this.$parent.isUser;
    },

    showSecondQue() {
      return function (info) {
        if (info.secondLevel) {
          if (info.parentKey === 'isMedicine') {
            return this.question[info.parentKey] === '1';
          } else {
            return this.question[info.parentKey] === '2' || this.question[info.parentKey] === '3';
          }
        } else {
          return true
        }
      }
    }
  },
}
</script>
<style scoped>
/deep/.van-field__label {
  color: #2b2c2c;
  text-align: left;
  word-wrap: break-word;
  font-size: 15px;
  margin-bottom: 8px;
}
/deep/.van-field__body {
  font-size: 15px;
}
</style>
<style scoped>

	.index {
		height: calc(100% - 48px);
		padding-top: 48px;
		background-color: rgba(255, 255, 255, .7);
    overflow: auto;
	}

	.index .head * {
		color: #FFFFFF;
	}

  /deep/.van-nav-bar__title {
    max-width: 60%;
    margin: 0 auto;
    color: #ffffff;
    font-weight: 500;
    font-size: 16px;
  }

	.index .head .van-nav-bar__content {
		height: 48px;
	}

  .submit-fix {
    position: fixed;
    margin: 16px;
    bottom: 12px;
    right: 12px;
    left: 12px;
  }

  .question-main {
   /* padding-top: 20px;*/
    margin-bottom: 90px;
  }

  /deep/ .van-cell {
    font-size: 13px;
    padding: 4px 16px;
  }

  .question-main .area-content{
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    background: #f9f9f9;
    padding: 10px 16px;
  }

  .question-main .title {
    margin: 0;
    padding: 10px 16px 10px 16px;
    color: rgba(31, 33, 33, 1);
    font-size: 15px;
    line-height: 16px;
    font-weight: 600;
  }

  .question-main .question {
    padding: 6px;
    line-height: 20px;
    font-size: 15px;
  }

  >>>.no-form-label .van-field__label {
    display: none;
  }

  .van-radio {
    margin-bottom: 8px;
  }

  .van-checkbox {
    margin-bottom: 8px;
  }

</style>



// WEBPACK FOOTER //
// src/user/Index.vue